export default __webpack_public_path__ + "static/media/nicolas_rage.1a25b5c3.png";